import { createServerFn } from "@tanstack/react-start";
import { logError, logInfo } from "@/lib/structured-log";
import type { DealCompanyResponse } from "@/lib/api/generated";
import { getDealCompanyInfoApiWorkspacesWorkspaceIdCampaignsCampaignIdDealsDealIdCompanyGet } from "@/lib/api/generated/campaigns/campaigns";

export const getDealCompanyInfoServer = createServerFn({ method: "GET" })
  .validator((data: { workspaceId: string; campaignId: string; dealId: string }) => data)
  .handler(async ({ data }): Promise<DealCompanyResponse | null> => {
    logInfo("deals.company.info.get.started", {
      workspace_id: data.workspaceId,
      campaign_id: data.campaignId,
      deal_id: data.dealId,
    });

    try {
      const response =
        await getDealCompanyInfoApiWorkspacesWorkspaceIdCampaignsCampaignIdDealsDealIdCompanyGet(
          data.workspaceId,
          data.campaignId,
          data.dealId,
        );

      if (response.status !== 200) {
        logError("deals.company.info.get.failed", {
          status: response.status,
          workspace_id: data.workspaceId,
          campaign_id: data.campaignId,
          deal_id: data.dealId,
        });
        throw new Error(`Failed to get deal company info: ${response.status}`);
      }

      const company = response.data as unknown as DealCompanyResponse | null;
      logInfo("deals.company.info.get.completed", { company_id: company?.id });
      return company;
    } catch (error) {
      logError("deals.company.info.get.error", {
        error: error instanceof Error ? error.message : "unknown-error",
        workspace_id: data.workspaceId,
        campaign_id: data.campaignId,
        deal_id: data.dealId,
      });
      throw error;
    }
  });
